import { createApp } from "vue"
import { setLocaleFromUrl } from "@/locales/i18n"
import App from "./App.vue"
import AppLoading from "./components/common/app-loading.vue"
import { setupDirectives } from "./directives"
import { setupRouter } from "./router"
import { setupAssets } from "./plugins"
import { setupStore } from "./store"
import { setupI18n } from "./locales"
import "./utils/service/disableDevtool"

async function setupApp() {
    // 如果url有传值需要设置语言环境
    // 如果没有传值，则使用默认语言环境
    setLocaleFromUrl()
    // import assets: js、css
    setupAssets()

    // app loading
    const appLoading = createApp(AppLoading)

    appLoading.mount("#appLoading")

    const app = createApp(App)

    // store plugin: pinia
    setupStore(app)

    // vue custom directives
    setupDirectives(app)

    // vue router
    await setupRouter(app)

    setupI18n(app)

    appLoading.unmount()

    // mount app
    app.mount("#app")
}

setupApp()
